// extracted by mini-css-extract-plugin
export default {"blockImage":"BlockImage_blockImage__HcXNf"};